import axios, { AxiosRequestConfig } from 'axios';

const API = (baseURL: string) => {
  const axiosRequestConfig: AxiosRequestConfig = {
    baseURL,
    headers: {
      Origin: 'https://uat.seedsddg.cropwise.com',
    },
  };

  const axiosInstance = axios.create(axiosRequestConfig);
  return axiosInstance;
};

export default API;
